import { enhancedMakeFetchAction } from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

export const POST_SIGNUP = 'EMPLOYEE/POST_SIGNUP'

const apiCall = enhancedMakeFetchAction(POST_SIGNUP, payload => ({
  endpoint: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/users/signup`,
  method: 'POST',
  body: payload,
  notify: true,
  isStay: true
}))

export default apiCall
